module.exports = __webpack_public_path__ + "img/soleil.59e6306.webp";